// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"16d5b7ab","513":"63458206","703":"beb4f62d"}[chunkId] + ".chunk.js";
};